import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { selectAccessAlertAdmin } from 'src/app/core/store/access/access.selectors';
import { IconComponent } from '../../../../shared/components/icon/icon.component';

export interface ContactAdminData {
  adminName?: string;
  adminEmail?: string;
  adminPhone?: string;
}

@Component({
  standalone: true,
  selector: 'app-contact-admin',
  imports: [CommonModule, IconComponent],
  templateUrl: './contact-admin.component.html',
  styleUrl: './contact-admin.component.scss',
})
export class ContactAdminComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ContactAdminComponent, string> | null>(MatDialogRef, { optional: true });
  store = inject(Store);
  accessAlertAdmin = toSignal(this.store.select(selectAccessAlertAdmin), { initialValue: null });

  action = output<string>();

  adminName = '';
  adminEmail = '';

  ngOnInit() {
    const first = this.accessAlertAdmin()?.firstname ?? '';
    const last = this.accessAlertAdmin()?.lastname ?? '';
    this.adminName = `${first}${last ? ' ' + last : ''}`.trim();
    this.adminEmail = this.accessAlertAdmin()?.email ?? '';
  }

  onUnderstand() {
    if (this.dialogRef) {
      this.dialogRef.close('understand');
    } else {
      this.action.emit('understand');
    }
  }

  onClose() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.action.emit('close');
    }
  }
}
